import { isAsyncFunction, notifyError, notifySuccess } from '@nutastic/nutastic-react-app';
import { CONSTANTS } from '../utils/constants.js';
import AuthService from '../services/AuthService.js';

const WebsiteActions = {
    REUP_STARTED: 'REUP_STARTED',
    REUP_DONE: 'REUP_DONE',
    REUP_FAIL: 'REUP_FAIL',
    LOADING_PAGE_START: 'LOADING_PAGE_START',
    LOADING_PAGE_DONE: 'LOADING_PAGE_DONE',
    LOADING_PAGE_FAIL: 'LOADING_PAGE_FAIL',
    APP_ANIMATION_CHANGE: 'APP_ANIMATION_CHANGE',
    REGISTER_STARTED: 'REGISTER_STARTED',
    REGISTER_COMPLETE: 'REGISTER_COMPLETE',
    REGISTER_FAIL: 'REGISTER_FAIL',
    LOGIN_STARTED: 'LOGIN_STARTED',
    LOGIN_COMPLETE: 'LOGIN_COMPLETE',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGOUT: 'LOGOUT',
    ORDER_SUBMIT_STARTED: 'ORDER_SUBMIT_STARTED',
    ORDER_SUBMIT_COMPLETED: 'ORDER_SUBMIT_COMPLETED',
    ORDER_SUBMIT_FAILED: 'ORDER_SUBMIT_FAILED',
    FAST_FETCH_STARTED: 'FAST_FETCH_STARTED',
    FAST_FETCH_DONE: 'FAST_FETCH_DONE',
    ACCOUNT_MODAL_SHOW: 'ACCOUNT_MODAL_SHOW',
    ACCOUNT_MODAL_HIDE: 'ACCOUNT_MODAL_HIDE',
    ACCOUNT_FETCH_STARTED: 'ACCOUNT_FETCH_STARTED',
    ACCOUNT_FETCH_DONE: 'ACCOUNT_FETCH_DONE',
    ACCOUNT_FETCH_FAIL: 'ACCOUNT_FETCH_FAIL'
};

const authLoginFailMessages = [
    "Those credentials don't work around these parts here buddy...try again!",
    "Blocked by JAMES! Now get out of here Andre Igoudala, AI would never...try again!",
    "Dikembe Mutombo is working hard at our network to block all bad credentials...please try again",
    "We can't let you in the club, you brought the wrong ID my friend...please try again",
    "Going to need to see some ID if you keep this up...try again",
    "I know we hear you knocking...we just don't know you. Try again...",
    "If you keep trying you might accidentally put in the right password...try again"
];

const triggerAction = type => {
    return { type };
};

const rehydrateState = () => {
    return async (dispatch) => {
        dispatch({ type: WebsiteActions.REUP_STARTED });
        console.log('Need to implement state water flow');
    };
};

const logIntoApplication = ({ email, password, onSuccess }) => {
    return async (dispatch) => {
        dispatch({ type: WebsiteActions.LOGIN_STARTED });
        try {
            const {isLoggedIn, accountInfo} = await AuthService.loginUser(({ email, password }));
            if (isLoggedIn) {
                dispatch({ type: WebsiteActions.LOGIN_COMPLETE, accountInfo });
                onSuccess && onSuccess();
            } else {
                dispatch({ type: WebsiteActions.LOGIN_FAILED, authError: 'Invalid credentials' });
                notifyError(null, null, authLoginFailMessages[Math.floor(Math.random() * authLoginFailMessages.length)]);
            }
        } catch (ex) {
            console.error('Unable to process login', ex);
            dispatch({ type: WebsiteActions.LOGIN_FAILED, authError: 'Unable to complete login' });
            notifyError(null, null, 'An error occurred, we will fix the issue if this continues to happen.');
        }
    };
};

const registerAccount = ({ firstName, lastName, email, password, passwordConfirm }) => {
    return async (dispatch) => {
        dispatch({ type: WebsiteActions.REGISTER_STARTED });
        try {
            const { accountInfo } = await AuthService.registerAccount(({ firstName, lastName, email, password, passwordConfirm }));
            if (accountInfo) {
                dispatch({ type: WebsiteActions.REGISTER_COMPLETE, accountInfo });
                notifySuccess('Successfully Logged In');
            } else {
                notifyError(null, null, 'Uh oh, try again!');
                dispatch({ type: WebsiteActions.REGISTER_FAIL, authError: 'Failed to setup account' });
            }
        } catch (ex) {
            console.error('Unable to register account', ex);
            dispatch({ type: WebsiteActions.REGISTER_FAIL, authError: 'Unable to register account' });
        }
    };
};

const forgotPasswordRequest = ({ email }) => {
    return async () => {
        try {
            const result = await AuthService.resetPasswordRequest(({ email }));
            if (result) {
                notifySuccess('Password assistance is on the way! Check your email for more details.');
            } else {
                notifyError(null, null, "No account found, please try again!");
            }
        } catch (ex) {
            console.error('An error occurred during password assistance process...', ex);
        }
    };
};

const animateToNextPage = ({ direction, asyncActionFn, onUrlReadyToChange }) => {
    return async (dispatch, state) => {
        dispatch({ type: WebsiteActions.LOADING_PAGE_START });
        try {
            if ( asyncActionFn && isAsyncFunction(asyncActionFn) ) {
                await asyncActionFn(dispatch, state);
            }
            dispatch(changeAppAnimationDirection(direction || null));
            dispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
            onUrlReadyToChange();
        } catch (e) {
            console.error(`Failed to go to next page`, e);
            dispatch({ type: WebsiteActions.LOADING_PAGE_FAIL });
        }
    };
};

const changeAppAnimationDirection = direction => {
    return async (dispatch) => {
        dispatch({ type: WebsiteActions.APP_ANIMATION_CHANGE, direction });
        setTimeout(
            () => dispatch({ type: WebsiteActions.APP_ANIMATION_CHANGE, direction: false }),
            CONSTANTS.APP_TRANSITION_TIME + 250
        );
    };
};

const quickCall = ({ title, asyncFetchCall, onSuccess, onError }) => {
    return async (dispatch) => {
        dispatch({ type: WebsiteActions.FAST_FETCH_STARTED });
        console.log(`Making a quick call for: ${title}`);
        try {
            const fetchResult = await asyncFetchCall();
            if(fetchResult) {
                onSuccess(fetchResult);
            } else {
                onError(fetchResult);
            }
        } catch (e) {
            console.error('Unable to complete fast fetch', e);
            onError();
        }
        dispatch({ type: WebsiteActions.FAST_FETCH_DONE });
    }
}

export {
    WebsiteActions,
    animateToNextPage,
    changeAppAnimationDirection,
    rehydrateState,
    logIntoApplication,
    registerAccount,
    forgotPasswordRequest,
    quickCall
};
